import { RenderIfProps } from './RenderIf.interface';

export const RenderIf = ({ value, children, elseComponent }: RenderIfProps): JSX.Element | null => {
    if (value) {
        return (
            <>{ children }</>
        );
    }

    if (elseComponent) {
        return (
            <>{ elseComponent }</>
        );
    }

    return null;
};
